<template>
  <div v-if="data" class="relative h-full pb-4 overflow-x-auto bg-white">
    <table class="w-full text-sm text-left text-gray-900 divide-y divide-gray-200">
      <tbody>
        <BaseDetailsTableRow
          :name="$t('material.code')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.code"
            color="base"
            flat
            :disabled="mode == 'view'"
            show-error-as-tooltip
            :error="codeErrorMessage" />
        </BaseDetailsTableRow>
        <BaseDetailsTableRow
          :name="$t('material.name')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.name"
            color="base"
            flat
            :disabled="mode == 'view'"
            show-error-as-tooltip
            :error="nameErrorMessage" />
        </BaseDetailsTableRow>
        <BaseDetailsTableRow
          :mode="mode"
          :name="$t('series.prefix')"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.prefix"
            color="base"
            flat
            :disabled="mode == 'view'" />
        </BaseDetailsTableRow>
        <BaseDetailsTableRow
          :mode="mode"
          :name="$t('series.suffix')"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.suffix"
            color="base"
            flat
            :disabled="mode == 'view'" />
        </BaseDetailsTableRow>
        <BaseDetailsTableRow
          :mode="mode"
          :name="$t('series.sequence')"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.sequence"
            color="base"
            flat
            type="number"
            :disabled="mode == 'view'"
            show-error-as-tooltip
            :error="mode == 'view' ? '' : sequenceErrorMessage" />
        </BaseDetailsTableRow>
        <BaseDetailsTableRow
          :mode="mode"
          :name="$t('series.automaticNumber')"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellStatus
            v-if="mode == 'view'"
            :item="data.hasAutomaticNumbering ? data.hasAutomaticNumbering : 0"
            :textTrue="$t('common.actions.yes')"
            :textFalse="$t('common.actions.no')" />
          <BaseToggle
            v-else
            :label="data.hasAutomaticNumbering ? $t('common.actions.yes') : $t('common.actions.no')"
            name="hasAutomaticNumbering"
            v-model="data.hasAutomaticNumbering" />
        </BaseDetailsTableRow>
        <BaseDetailsTableRow
          :mode="mode"
          :name="$t('series.cancelingSeries')"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellStatus
            v-if="mode == 'view'"
            :item="data.isCancelingSeries ? data.isCancelingSeries : 0"
            :textTrue="$t('material.active')"
            :textFalse="$t('material.inactive')" />
          <BaseToggle
            v-else
            :label="data.isCancelingSeries ? $t('material.active') : $t('material.inactive')"
            name="isCancelingSeries"
            v-model="data.isCancelingSeries" />
        </BaseDetailsTableRow>
        <BaseDetailsTableRow
          :mode="mode"
          :name="$t('baseObject.isActive')"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellStatus
            v-if="mode == 'view'"
            :item="data.isActive ? data.isActive : 0"
            :textTrue="$t('material.active')"
            :textFalse="$t('material.inactive')" />
          <BaseToggle
            v-else
            :label="data.isActive ? $t('material.active') : $t('material.inactive')"
            name="isActive"
            v-model="data.isActive" />
        </BaseDetailsTableRow>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import BaseInput from '@/components/common/BaseInput.vue';
import BaseToggle from '@/components/common/BaseToggle.vue';
import BaseDetailsTableRow from '@/components/common/BaseDetailsTableRow.vue';
import BaseTableCellStatus from '../common/BaseTableCellStatus.vue';

import type { DocumentSeries } from '@/types/DocumentSeries';

const data = defineModel<DocumentSeries>();

defineProps<{
  mode: 'view' | 'edit';
  isHorizontalLayout: boolean;
  codeErrorMessage: string;
  nameErrorMessage: string;
  sequenceErrorMessage: string;
}>();
</script>
